// The version of the trees list, as the API reports it (`count:maxId`). It is a few bytes on the device, and it is
// what lets a start serve the stored map files - and the light trees list copy - without asking for them again.

const TREES_LIST_VERSION_PREFIX = 'tw.treesListVersion.';

export const treesListVersion = (list: { count?: number; maxId?: number | null }): string =>
  `${list.count ?? ''}:${list.maxId ?? ''}`;

export const readTreesListVersion = (contractId: string): string | null => {
  try {
    return localStorage.getItem(TREES_LIST_VERSION_PREFIX + contractId);
  } catch (error) {
    return null;
  }
};

export const writeTreesListVersion = (contractId: string, version: string) => {
  try {
    localStorage.setItem(TREES_LIST_VERSION_PREFIX + contractId, version);
  } catch (error) {
    console.warn('could not remember the trees list version', error);
  }
};

// A tree planted or removed makes the stored files out of date. What the map remembered about them is keyed by
// this number, so bumping it is all it takes for the next map to ask the API again and read the files afresh.
let revision = 0;

export const mapTreesListVersion = (): number => revision;

export const invalidateTreesListVersion = (): void => {
  revision += 1;
};
